import { CollectionName, CollectionVisibility } from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const phytoBotanicalNameSchema: CollectionCreateSchema = {
  name: CollectionName.PhytoBotanicalName,
  enable_nested_fields: true,
  symbols_to_index: ["~"],
  fields: [
    {
      name: "id",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "botanical_name",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "common_name",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "effective_start_date",
      type: "int64",
      sort: true,
      infix: true,
    },
    {
      name: "effective_end_date",
      type: "int64",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "active",
      type: "bool",
      sort: true,
    },
    {
      name: "updated_at",
      type: "int64",
      sort: true,
      infix: true,
    },
    {
      name: "updated_by",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
  ],
  visibility: CollectionVisibility.Public,
}
